import React, { useContext, useEffect, useState } from 'react';
import Sidebar from './../Sidebar';
import Footer from './../Footer';
import { AuthContext } from './../AuthContext';
import { site_url_img, site_url } from "./../config.js";
import { useLocation } from "react-router-dom";
import axios from 'axios';

function Index() {
  const { user, refreshUser, vendordetails, fetchUserData, logout } = useContext(AuthContext);
  const location = useLocation();

  // Profile edit modal state
  const [showProfileModal, setShowProfileModal] = useState(false);
  const [profileForm, setProfileForm] = useState({ username: '', address: '', city: '', state: '', pincode: '', gst: '' });
  const [profilePicFile, setProfilePicFile] = useState(null);
  const [profilePicPreview, setProfilePicPreview] = useState(null);
  const [profileSaving, setProfileSaving] = useState(false);
  const [profileMsg, setProfileMsg] = useState({ type: '', text: '' });
  const [logoutAllLoading, setLogoutAllLoading] = useState(false);

  // Email verification states
  const [newEmail, setNewEmail] = useState('');
  const [editingEmail, setEditingEmail] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [emailOtp, setEmailOtp] = useState('');
  const [emailVerifyMsg, setEmailVerifyMsg] = useState({ type: '', text: '' });
  const [canResend, setCanResend] = useState(true);
  const [timer, setTimer] = useState(0);
  const [showEmailVerify, setShowEmailVerify] = useState(false);

  useEffect(() => {
    // Remove modal backdrops
    const backdrops = document.querySelectorAll(".modal-backdrop");
    backdrops.forEach((el) => el.remove());

    // Remove modal-open class
    document.body.classList.remove("modal-open");

    // Remove inline styles like overflow and padding
    document.body.style.overflow = "";
    document.body.style.paddingRight = "";
  }, [location]);

  useEffect(() => {
    let interval;
    if (timer > 0) {
      interval = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
    } else {
      setCanResend(true);
    }
    return () => clearInterval(interval);
  }, [timer]);

  const handleSendEmailOtp = async () => {
    const token = localStorage.getItem('access_token');
    if (!token) {
      setEmailVerifyMsg({ type: 'error', text: 'Authentication required. Please login again.' });
      return;
    }
    
    try {
      setEmailVerifyMsg({ type: 'info', text: 'Sending OTP...' });

      // Get vendor ID from localStorage
      const userId = localStorage.getItem('user_id');

      const payload = {
        vendor_id: userId
      };
      if (editingEmail && newEmail && newEmail !== vendordetails?.user_details?.email) {
        payload.email = newEmail;
      } else {
        payload.email = vendordetails?.user_details?.email;
      }

      const res = await axios.post(site_url + '/vendor/send-email-otp', payload);
      if (res.data.status === 'success') {
        setShowEmailVerify(true);
        setEditingEmail(false);
        setEmailVerifyMsg({ type: 'success', text: 'OTP sent to email.' });
        setTimer(60);
        setCanResend(false);
      } else {
        setEmailVerifyMsg({ type: 'error', text: res.data.message || 'Failed to send OTP.' });
      }
    } catch (err) {
      setEmailVerifyMsg({ type: 'error', text: err.response?.data?.message || 'Error sending OTP.' });
    }
  };

  const handleVerifyEmailOtp = async () => {
    const userId = localStorage.getItem('user_id');
    if (!userId) {
      setEmailVerifyMsg({ type: 'error', text: 'Authentication required. Please login again.' });
      return;
    }
    
    try {
      const res = await axios.post(site_url + '/vendor/verify-email-otp', {
        vendor_id: userId,
        otp: emailOtp
      });
      if (res.data.status === 'success') {
        setShowEmailVerify(false);
        setShowSuccessModal(true);
      } else {
        setEmailVerifyMsg({ type: 'error', text: res.data.message || 'Invalid OTP.' });
      }
    } catch (err) {
      setEmailVerifyMsg({ type: 'error', text: 'Verification failed.' });
    }
  };

  const openProfileModal = () => {
    const ud = vendordetails?.user_details || {};
    setProfileForm({
      username: ud.username || '',
      address: ud.address || '',
      city: ud.city || '',
      state: ud.state || '',
      pincode: ud.pincode || '',
      gst: ud.gst || ''
    });
    setProfilePicFile(null);
    setProfilePicPreview(null);
    setProfileMsg({ type: '', text: '' });
    setShowProfileModal(true);
  };

  const handleProfilePicChange = (e) => {
    const file = e.target.files?.[0];
    if (file) {
      setProfilePicFile(file);
      setProfilePicPreview(URL.createObjectURL(file));
    }
  };

  const handleProfileSubmit = async (e) => {
    e.preventDefault();
    setProfileSaving(true);
    setProfileMsg({ type: '', text: '' });
    try {
      const formData = new FormData();
      if (profileForm.username !== undefined) formData.append('username', profileForm.username);
      if (profileForm.address !== undefined) formData.append('address', profileForm.address);
      if (profileForm.city !== undefined) formData.append('city', profileForm.city);
      if (profileForm.state !== undefined) formData.append('state', profileForm.state);
      if (profileForm.pincode !== undefined) formData.append('pincode', profileForm.pincode);
      if (profileForm.gst !== undefined) formData.append('gst', profileForm.gst);
      if (profilePicFile) formData.append('shop_img', profilePicFile);

      const token = localStorage.getItem('jwt_token') || localStorage.getItem('access_token');
      const res = await axios.post(site_url + '/vendor/update-profile', formData, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (res.data.status === 'success') {
        setShowProfileModal(false);
        if (fetchUserData) fetchUserData();
      } else {
        setProfileMsg({ type: 'error', text: res.data.message || 'Update failed.' });
      }
    } catch (err) {
      setProfileMsg({ type: 'error', text: err.response?.data?.message || 'Failed to update profile.' });
    } finally {
      setProfileSaving(false);
    }
  };

  const handleLogoutAllDevices = async () => {
    if (!window.confirm('Log out from all devices? You will need to log in again on this device too.')) return;
    setLogoutAllLoading(true);
    try {
      const token = localStorage.getItem('jwt_token') || localStorage.getItem('access_token');
      await axios.post(site_url + '/vendor/logout-all-devices', {}, {
        headers: { Authorization: `Bearer ${token}` },
      });
    } catch (e) {
      // still logout locally even if API fails
    }
    logout();
    window.location.href = '/login';
    setLogoutAllLoading(false);
  };

  return (
    <div>
      <div id="appCapsule">
        <div className="listview-title mt-1">Email Verification</div>
        <div className="section inset mb-2">
          <div className="wide-block pt-2 pb-2">
            {!editingEmail ? (
              <div className="d-flex justify-content-between align-items-center">
                <span>
                  {vendordetails?.user_details?.email || 'No Email Set'}
                  {vendordetails?.user_details?.email_verified_at ? (
                    <span className="badge badge-success ms-2">Verified</span>
                  ) : (
                    <span className="badge badge-warning ms-2" onClick={handleSendEmailOtp} style={{ cursor: 'pointer' }}>Verify Now</span>
                  )}
                </span>
                <div onClick={() => {
                  setNewEmail(vendordetails?.user_details?.email || '');
                  setEditingEmail(true);
                }} style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', color: '#007bff' }}>
                  <ion-icon name="create-outline" style={{ fontSize: '20px', marginRight: '5px' }}></ion-icon>
                  <span style={{ fontSize: '14px', fontWeight: '500' }}>Update</span>
                </div>
              </div>
            ) : (
              <div className="d-flex align-items-center gap-2">
                <input
                  type="email"
                  className="form-control form-control-sm"
                  value={newEmail}
                  onChange={(e) => setNewEmail(e.target.value)}
                  placeholder="Enter new email"
                />
                <button className="btn btn-sm btn-primary" onClick={handleSendEmailOtp}>Save</button>
                <button className="btn btn-sm btn-secondary" onClick={() => setEditingEmail(false)}>Cancel</button>
              </div>
            )}
          </div>
        </div>

        <div className="section mt-3 text-center">
          <div className="avatar-section">
            <a href="#" onClick={(e) => { e.preventDefault(); openProfileModal(); }}>
              <img src={vendordetails?.user_details?.shop_img ? site_url_img + '/' + vendordetails.user_details.shop_img : 'https://via.placeholder.com/100'} alt="avatar" className="imaged w100 rounded" />
              <span className="button">
                <ion-icon name="camera-outline" role="img" className="md hydrated" aria-label="camera outline" />
              </span>
            </a>
          </div>
        </div>

        <div className="listview-title mt-1">Profile Settings</div>
        <ul className="listview image-listview text inset">
          <li>
            <a href="#" className="item">
              <div className="in">
                <div>{vendordetails?.user_details?.username}</div>
              </div>
            </a>
          </li>
          <li>
            <a href="#" className="item">
              <div className="in">
                <div>{vendordetails?.user_details?.phone}</div>
              </div>
            </a>
          </li>
          <li>
            <a href="#" className="item" onClick={(e) => { e.preventDefault(); openProfileModal(); }}>
              <div className="in">
                <div>{vendordetails?.user_details?.address} {vendordetails?.user_details?.city}/{vendordetails?.user_details?.state}-{vendordetails?.user_details?.pincode}</div>
                <span className="text-primary">Edit</span>
              </div>
            </a>
          </li>
          <li>
            <a href="#" className="item">
              <div className="in">
                <div>{vendordetails?.user_details?.gst}</div>
              </div>
            </a>
          </li>
        </ul>
        <div className="listview-title mt-1">Security</div>
        <ul className="listview image-listview text mb-2 inset">
         

          <li>
            <a href="#" className="item" onClick={(e) => { e.preventDefault(); handleLogoutAllDevices(); }}>
              <div className="in">
                <div>Log out all devices</div>
                {logoutAllLoading && <span className="text-muted small">Logging out...</span>}
              </div>
            </a>
          </li>
        </ul>
      </div>

      {/* Profile Edit Modal */}
      {showProfileModal && (
        <div
          className="modal fade action-sheet show"
          id="profileEditModal"
          tabIndex={-1}
          role="dialog"
          style={{ display: 'block' }}
        >
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Edit Profile</h5>
                <button type="button" className="btn-close" aria-label="Close" onClick={() => setShowProfileModal(false)} />
              </div>
              <div className="modal-body">
                <form onSubmit={handleProfileSubmit}>
                  {profileMsg.text && (
                    <div className={`alert alert-${profileMsg.type === 'error' ? 'danger' : 'success'} mb-2`}>{profileMsg.text}</div>
                  )}
                  <div className="text-center mb-3">
                    <label className="d-block mb-2">Profile picture</label>
                    <label className="d-inline-block position-relative" style={{ cursor: 'pointer' }}>
                      <img
                        src={profilePicPreview || (vendordetails?.user_details?.shop_img ? site_url_img + '/' + vendordetails.user_details.shop_img : 'https://via.placeholder.com/100')}
                        alt="Profile"
                        className="rounded"
                        style={{ width: '80px', height: '80px', objectFit: 'cover' }}
                      />
                      <span className="position-absolute bottom-0 end-0 bg-primary rounded-circle p-1">
                        <ion-icon name="camera-outline" style={{ fontSize: '18px', color: '#fff' }} />
                      </span>
                      <input type="file" accept="image/*" className="d-none" onChange={handleProfilePicChange} />
                    </label>
                  </div>
                  <div className="form-group basic">
                    <label className="label">Username</label>
                    <input
                      type="text"
                      className="form-control"
                      value={profileForm.username}
                      onChange={(e) => setProfileForm((p) => ({ ...p, username: e.target.value }))}
                      placeholder="Username"
                    />
                  </div>
                  <div className="form-group basic">
                    <label className="label">Address</label>
                    <input
                      type="text"
                      className="form-control"
                      value={profileForm.address}
                      onChange={(e) => setProfileForm((p) => ({ ...p, address: e.target.value }))}
                      placeholder="Address"
                    />
                  </div>
                  <div className="row">
                    <div className="col-6">
                      <div className="form-group basic">
                        <label className="label">City</label>
                        <input
                          type="text"
                          className="form-control"
                          value={profileForm.city}
                          onChange={(e) => setProfileForm((p) => ({ ...p, city: e.target.value }))}
                          placeholder="City"
                        />
                      </div>
                    </div>
                    <div className="col-6">
                      <div className="form-group basic">
                        <label className="label">State</label>
                        <input
                          type="text"
                          className="form-control"
                          value={profileForm.state}
                          onChange={(e) => setProfileForm((p) => ({ ...p, state: e.target.value }))}
                          placeholder="State"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-6">
                      <div className="form-group basic">
                        <label className="label">Pincode</label>
                        <input
                          type="text"
                          className="form-control"
                          value={profileForm.pincode}
                          onChange={(e) => setProfileForm((p) => ({ ...p, pincode: e.target.value }))}
                          placeholder="Pincode"
                        />
                      </div>
                    </div>
                    <div className="col-6">
                      <div className="form-group basic">
                        <label className="label">GST</label>
                        <input
                          type="text"
                          className="form-control"
                          value={profileForm.gst}
                          onChange={(e) => setProfileForm((p) => ({ ...p, gst: e.target.value }))}
                          placeholder="GST"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="form-group basic mt-3">
                    <button type="submit" className="btn btn-primary btn-block btn-lg" disabled={profileSaving}>
                      {profileSaving ? 'Saving...' : 'Save Profile'}
                    </button>
                    <button type="button" className="btn btn-secondary btn-block mt-2" onClick={() => setShowProfileModal(false)}>
                      Cancel
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Email Verification Action Sheet Modal */}
      {showEmailVerify && (
        <div
          className="modal fade action-sheet show"
          id="emailVerifyActionSheet"
          tabIndex={-1}
          role="dialog"
          style={{ display: 'block' }}
        >
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Verify Email</h5>
              </div>
              <div className="modal-body">
                <div className="action-sheet-content">
                  {emailVerifyMsg.text && (
                    <div className={`alert alert-${emailVerifyMsg.type === 'error' ? 'danger' : emailVerifyMsg.type === 'success' ? 'success' : 'info'} mb-2`}>
                      {emailVerifyMsg.text}
                    </div>
                  )}
                  <form>
                    <div className="form-group basic">
                      <div className="input-wrapper">
                        <label className="label">Enter OTP</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter 4-digit OTP"
                          value={emailOtp}
                          onChange={(e) => setEmailOtp(e.target.value)}
                        />
                        <i className="clear-input">
                          <ion-icon name="close-circle" onClick={() => setEmailOtp('')}></ion-icon>
                        </i>
                      </div>
                    </div>

                    <div className="form-group basic mt-3">
                      <button
                        type="button"
                        className="btn btn-primary btn-block btn-lg mb-2"
                        onClick={handleVerifyEmailOtp}
                      >
                        Verify OTP
                      </button>

                      <div className="d-flex justify-content-between align-items-center px-1">
                        <button
                          type="button"
                          className="btn btn-text-secondary btn-sm"
                          onClick={() => setShowEmailVerify(false)}
                        >
                          Cancel
                        </button>

                        <button
                          type="button"
                          className="btn btn-text-primary btn-sm"
                          onClick={handleSendEmailOtp}
                          disabled={!canResend}
                          style={{ opacity: canResend ? 1 : 0.6 }}
                        >
                          {canResend ? 'Resend Code' : `Resend in ${timer}s`}
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Success Modal */}
      {showSuccessModal && (
        <div
          className="modal fade action-sheet show"
          id="successActionSheet"
          tabIndex={-1}
          role="dialog"
          style={{ display: 'block' }}
        >
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Success</h5>
              </div>
              <div className="modal-body">
                <div className="action-sheet-content">
                  <div className="text-center mb-2">
                    <div
                      style={{
                        width: '80px',
                        height: '80px',
                        backgroundColor: 'rgba(50, 168, 82, 0.1)',
                        borderRadius: '50%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        margin: '0 auto 15px auto'
                      }}
                    >
                      <ion-icon name="checkmark-circle-outline" style={{ fontSize: '40px', color: '#32a852' }}></ion-icon>
                    </div>
                  </div>
                  <h3 className="text-center mb-1">Email Verified!</h3>
                  <p className="text-center mb-3">
                    Your email has been successfully verified. You will receive monthly statements and important updates.
                  </p>

                  <div className="form-group basic">
                    <button
                      type="button"
                      className="btn btn-primary btn-block btn-lg"
                      onClick={() => {
                        setShowSuccessModal(false);
                        refreshUser();
                      }}
                    >
                      Continue
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      <Footer />
      <Sidebar />
    </div>
  )
}

export default Index;
